import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  Parameters,
  PledgeRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { Fees } from '@app/forms/subscription/definition/interface/subscription';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generate(entity: PledgeRead) {
    const parameters: Parameters = {
      ...entity?.parameters,
    };
    let options: AbstractControlOptions = {};
    const formConfig: FormConfig<Fees> = {
      fees: [parameters?.fees * 100 || 0, Validators.required],
      dateSignature: [
        parameters?.dateSignature || new Date(),
        Validators.required,
      ],
      placeSignature: [parameters?.placeSignature || null, Validators.required],
    };

    return this.formBuilder.group(formConfig, options);
  }

  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }
  extract() {
    return {
      fees: this.form.get('fees')?.value / 100,
      dateSignature: this.form.get('dateSignature').value,
      placeSignature: this.form.get('placeSignature').value,
    };
  }
}
